export var FOOTER = "FOOTER";
export var FOOTER_STREAM = "FOOTER_STREAM";
export var SHOW_FOOTER = "SHOW_FOOTER";
export var SHOW_FOOTER_UI = "SHOW_FOOTER_UI";
export var UPDATE_CHATBOT = "UPDATE_CHATBOT";
export var HIDE_CHATBOT = "HIDE_CHATBOT";
export var MARKET_STATUS_START_LOADER = "MARKET_STATUS_START_LOADER";
export var MARKET_STATUS_STOP_LOADER = "MARKET_STATUS_STOP_LOADER";
